import { render } from "./updatecomp.vue?vue&type=template&id=1763b552"
import script from "./updatecomp.vue?vue&type=script&lang=js"
export * from "./updatecomp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__